import '@fortawesome/fontawesome-free/css/all.min.css'
import 'bootstrap-css-only/css/bootstrap.min.css'
import 'mdbvue/lib/css/mdb.min.css'
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuexI18n from 'vuex-i18n';
Vue.config.productionTip = false

import {mdbInput, mdbBtn} from "mdbvue"
Vue.component('mdb-input', mdbInput);
Vue.component('mdb-btn', mdbBtn);

import VueAnalytics from 'vue-analytics'

Vue.use(VueAnalytics, {
  id: 'UA-131676042-3',
  router,
  debug: {
    sendHitTask: process.env.NODE_ENV === 'production'
  }
})

import wb from "./registerServiceWorker";
Vue.prototype.$workbox = wb;

Vue.use(vuexI18n.plugin, store);

import Notify from 'mdbvue/lib/components/Notify'
Vue.use(Notify)

//import en from '@/translations/en.json';
import fr from '@/translations/fr.json';
//Vue.i18n.add('en-US', en);
Vue.i18n.add('fr', fr);
//Vue.i18n.fallback('en-US');
Vue.i18n.set('fr');
/*
var locale = require('browser-locale')()
console.log(locale);
if (locale && Vue.i18n.localeExists(locale))
  Vue.i18n.set(locale);
else
  Vue.i18n.set('en-US');
*/

store.dispatch("auth/listenToLogin");

Vue.$ga.disable();
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')

export const ga = Vue.$ga
